import { Paging, Assetsfilter } from '../../core/models/am-helper.model';
import template from './operator-assets-list.html';
import { isArrayNotEmpty, pollOnInterval } from '../../core/utilities/am-helper.util';

class AmOperatorAssetListController {
  constructor($state, amAssetsService, amAssignmentService, $interval) {
    'ngInject';

    this.assets = [];
    this.pagedAssets = [];
    this.selectedAssets = {};
    this.status = '';
    this.$state = $state;
    this.assetService = amAssetsService;
    this.assignmentService = amAssignmentService;
    this.paging = new Paging(10, 1);
    this.total = 0;
    this.filter = new Assetsfilter();
    this.interval = $interval;
    this.propertyKeys = ['name', 'make', 'model', 'year'];
    this.addToDataLayer = (data) => window.dataLayer.push(data);
  }

  get SelectedArray() {
    return Object.keys(this.selectedAssets || {});
  }

  $onInit() {
    this.status = 'loading';
    this.getAssigndAssets().then(() => {
      this.updateInterval = pollOnInterval(this.interval, () => this.getAssigndAssets());
    });
  }

  $onChanges() {}

  $onDestroy() {
    if (this.updateInterval) {
      this.interval.cancel(this.updateInterval);
    }
  }

  getAssigndAssets() {
    return this.assetService
      .getAssetsByOperatorId(this.operatorId)
      .then((result) => {
        this.assets = result.assets || [];
        this.loadCurrentPage();
        this.status = '';
        this.onUpdate({ assetsTotal: this.assets.length });
      })
      .catch(() => {
        this.status = 'error';
      });
  }

  onTriggerSearch(term) {
    this.filter.query = term ? `*${term}*` : '*';
    this.paging.reset();
    this.loadCurrentPage();

    this.addToDataLayer({
      event: 'assetSearching',
      data: {
        keyword: term,
        page: this.$state.current.name,
      },
    });
  }

  loadCurrentPage() {
    this.assetService
      .getPagedAssets(this.filter, this.paging, this.assets, this.propertyKeys)
      .then((result) => {
        this.pagedAssets = result.data;
        this.total = result.total;
      })
      .catch(() => {});
  }

  viewAsset(asset) {
    if (asset) {
      this.$state.go('access-management.asset-view', {
        id: asset.id,
      });
    }
  }

  addAssets() {
    const alreadyAddedAssets = (this.assets || []).map((asset) => asset.id);
    this.assetService
      .openSelectAssetPopup({}, alreadyAddedAssets)
      .then((result) => {
        const assetsIds = Object.keys(result);
        this.assignAssetsToOperator(assetsIds);
      })
      .catch(() => {});
  }

  assignAssetsToOperator(assetsIds = []) {
    // validate input
    if (!isArrayNotEmpty(assetsIds)) return;

    this.assignmentService
      .assign(assetsIds, [this.operatorId])
      .then((result) => {
        this.getAssigndAssets();
      })
      .catch(() => {
        this.status = 'add-error';
      });
  }

  unassignAssets(assetsIds = []) {
    if (!isArrayNotEmpty(assetsIds)) return;
    this.assignmentService
      .unassign(assetsIds, [this.operatorId])
      .then((result) => {
        this.selectedAssets = {};
        this.getAssigndAssets();
      })
      .catch(() => {
        this.status = 'remove-error';
      });
  }

  removeSelected() {
    const assetsIds = this.SelectedArray;
    this.unassignAssets(assetsIds);
  }
}

export default {
  template,
  controller: AmOperatorAssetListController,
  controllerAs: 'opAssetsVm',
  bindings: {
    operatorId: '<',
    assets: '<',
    onAdd: '&',
    onRemove: '&',
    status: '<',
    onRefresh: '&',
    onUpdate: '&',
  },
};
